export const CART_QUICK_ORDER_FEATURE = 'cartQuickOrder';
export const CART_QUICK_ORDER_CORE_FEATURE = 'cartQuickOrderCore';
